import { ContentCopyOutlined } from '@mui/icons-material';
import { Box, Divider, TextField, Stack, Typography } from '@mui/material';

import React from 'react';

import { toSentenceCase } from 'common/utils/utilFunctions';

import styles from './EventPayload.module.scss';

interface IEventPayloadProps {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const EventPayload = (props: IEventPayloadProps) => {
	const { onChange, value } = props;

	return (
		<Stack className={styles['payload-border']}>
			<Box className={styles['toolbar-header']}>
				<Typography className={styles['event-payload-text']}>
					{toSentenceCase('Event Payload')}
				</Typography>
				<Typography className={styles['copy-container']} component="div">
					<ContentCopyOutlined className={styles['copy-icon']} />
					<p className={styles['copy-style']}>Copy</p>
				</Typography>
			</Box>
			<Divider />
			<TextField
				value={value}
				multiline
				rows={value && value.length > 100 ? 10 : 4}
				onChange={onChange}
			/>
		</Stack>
	);
};

export default EventPayload;
